export type TemplateType = 'ServiceReminder';

interface TemplateRequirement {
  label: string;
  include: string;
}

export type TemplateRequirements = TemplateRequirement[];

interface TemplateConfig {
  requirements: TemplateRequirements;
}

export const TemplateConfigs: Record<TemplateType, TemplateConfig> = {
  ServiceReminder: {
    requirements: [
      {
        label: 'Service Reminder List',
        include: '{{#servicesList}}',
      },
    ],
  },
};
